import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  module: PropTypes.object.isRequired,
  removable: PropTypes.bool,
  canOpen: PropTypes.bool,
  openItemList: PropTypes.func,
  editModule: PropTypes.func,
  remove: PropTypes.func,
};

const defaultProps = {
  removable: false,
  canOpen: false,
  openItemList: () => {},
  editModule: () => {},
  remove: () => {},
};

const BaseModuleListItem = ({ module, removable, canOpen, openItemList, editModule, remove }) => (
  <div className="c-bb-basemodule-list__item">
    {!canOpen && <i className="c-bb-basemodule-list__edit icon-edit" onClick={() => editModule(module)} />}
    <div className="c-bb-basemodule-list__item-field">
      { module.icon && <i className={module.icon} /> }
      { module.label }
    </div>
    { removable &&
      <i className="c-bb-basemodule-list__item-remove icon-close" onClick={() => remove(module.id)} />
    }
    { canOpen &&
      <i className="c-bb-basemodule-list__item-remove icon-arrow-up" onClick={() => openItemList(module.id)} style={{ transform: 'rotate(90deg)' }} />
    }
  </div>
);

BaseModuleListItem.propTypes = propTypes;
BaseModuleListItem.defaultProps = defaultProps;

export default BaseModuleListItem;



// WEBPACK FOOTER //
// ./src/components/BaseModule/BaseModuleListItem.js